import React, { Component } from "react"
import Chevron from "ui/legacy/Chevron"
// required for typescript
// eslint-disable-next-line
import { TreeInstance } from "./tree/tree"
import Text from "../../ui/components/Text"

/**
 * @augments {Component<{context: BlockContext, tree: TreeInstance}, any>}
 */
class BreadCrumb extends Component {
    select = block => {
        this.props.context.actions.selectBlock(block.id)
    }
    renderItem = (block, i) => {
        if (!block) return
        return (
            <Chevron
                green
                key={block.id}
                height={30}
                onClick={() => this.select(block)}
                style={{ color: "white" }}
                onMouseOver={$event => {
                    this.props.context.actions.highlightElement(block.id)
                }}
                onMouseLeave={() => this.props.context.actions.stopHighlight()}
                number={i}
            >
                {block.config.attributes.label || block.id}
            </Chevron>
        )
    }
    getLists = blockId => {
        if (!blockId) return []
        let lastElement = blockId
        const tree = this.props.tree
        const list = [tree.indexedBlocks[lastElement]]
        while ((lastElement = tree.parentBlocks[lastElement])) {
            list.unshift(tree.indexedBlocks[lastElement])
        }

        return list
    }
    render() {
        const list = this.getLists(this.props.context.editor.selected)
        return <Text size="fontS" padding="none" margin="none" style={{ marginLeft: "-11px" }}>{list.map((block, i) => this.renderItem(block, i))}</Text>
    }
}

BreadCrumb.propTypes = {}

export default BreadCrumb



// WEBPACK FOOTER //
// ./src/features/editor/BreadCrumb.js